module.exports = __webpack_public_path__ + "static/media/top-bg-mob.9031e84d.svg";